module.exports = __webpack_public_path__ + "static/planwell_white-b99ac3027046ad8e3157beefe57fccf5.png";